<template>
  <material-card class=pt-2 full-header>
    <template #heading>
      <v-toolbar color="accent">
        <v-toolbar-title>
          <v-icon> mdi-google-classroom </v-icon>
          {{ room.name }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon dark class="mb-2" @click="close">
          <v-icon medium>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table :items="recordList" :headers="recordsHeader" :loading="loading" item-key="recordID" :search="search" :footer-props="{ showFirstLastPage: true}">
      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details>
            </v-text-field>
          </v-toolbar-title>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="getRecords">
                <v-icon medium>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("refresh") }}
            </span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <template v-slot:[`item.presentation`]="{ item }">
        <v-btn class="ma-2" text icon v-bind="attrs" v-on="on">
          <v-icon color="primary" medium @click="openLink(item, 'presentation')">mdi-presentation-play</v-icon>
        </v-btn>
        <!-- <span>{{ $t(item.playbackUrl) }}</span> -->
      </template>
      <template v-slot:[`item.video`]="{ item }">
        <v-btn class="ma-2" text icon v-bind="attrs" v-on="on">
          <v-icon color="primary" medium @click="openLink(item, 'video')">mdi-video-check-outline</v-icon>
        </v-btn>
        <!-- <span>{{ $t(item.playbackUrl) }}</span> -->
      </template>
      <!-- custom columns -->

    </v-data-table>
    <template #actions>

    </template>
  </material-card>
</template>
<script>

export default {
  name: "WebinarRoomRecords",
  props: {
    visible: Boolean,
    room: {},
  },
  computed: {

  },
  data() {
    return {

      recordsHeader: [
        { text: '', value: 'data-table-expand' },
        { value: "name", text: this.$t("name") },
        { value: "start_time", text: this.$t("start_time") },
        { value: "end_time", text: this.$t("end_time") },
        { value: "presentation", text: this.$t("presentation") },
        { value: "video", text: this.$t("video") },

      ],
      recordList: [],
      loading: true,
      totalServers: 0,
      options: {},
      itemPerPage: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 10,
      joinLoading: false,
      search: '',
      expanded: [],
      learningDashboardLoading: false,

    };
  },
  watch: {
    options: {
      handler() {
        this.getRecords();
      },
      deep: true,
    },
  },
  methods: {
    getRecords() {
      this.loading = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + `/api/webinar_plus/companies/${this.room.company_id}/rooms/${this.room.id}/records`,
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
      })
        .then((response) => {

          let data = response.data.records;
          if (data == undefined) return;
          this.recordList = data;//(Array.isArray(data) ? data : [{ ...data }]);
          this.loading = false;
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close')
    },
    openLink(item, recordFormat) {
      if (item.formats != null) {
        const formats = JSON.parse(item.formats);
        const record = formats.filter((format) => format.type === recordFormat);
        window.open(record[0].url);
      }
      else {
        if (recordFormat == 'video') 
          this.$toasted.error(this.$t("video_format_is_not_available"), { icon: { name: "alert-circle" } });
        else
          window.open(item.playbackUrl, "_blank");
      }
    }
  },
  mounted() {
    this.getRecords();
  },
};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>
  